<template>
  <div class="common-layout">
    <el-container>
      <el-main>
        <div style="margin: 50px 100px">
          <h2 style="font-size: 30px; color: #617173;">
            青年中醫師專業賦能計畫
          </h2>
          <div>
            <h2 style="font-size: 20px; color: #617173;margin-top: 10px">
              職業發展生態構建
            </h2>
            <p style="font-size: 20px; color: #617173; margin-top: 10px">
              「港澳中醫執業資格特訓營」
            </p>
            <p style="font-size: 20px; color: #617173;">
              邀請粵港澳衛生部門聯合解讀政策，提供考證輔導與跨境執業法律諮詢。
            </p>
            <p style="font-size: 20px; color: #617173;">
              推動建立大灣區「青年中醫多點執業聯盟」，試點中醫館連鎖品牌青年醫師共享執業模式。
            </p>
            <el-divider style="width: 1100px;margin-left: 30px" />
            <p style="font-size: 20px; color: #617173;">
              「青年中醫健康產品IP工坊」
            </p>
            <p style="font-size: 20px; color: #617173;">
              聯合澳門中葡商貿平臺，開發跨境中醫文創、藥食同源產品線。
            </p>
            <p style="font-size: 20px; color: #617173;">
              設立「中醫新業態實驗室」，探索中醫遠程診療、跨境中醫健康旅遊等創新服務模式。
            </p>
          </div>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <div>
            <h2 style="font-size: 20px; color: #617173;margin-top: 10px">
              職業發展導航體系
            </h2>
            <p style="font-size: 20px; color: #617173; margin-top: 10px">
              「中醫職業探險計劃」
            </p>
            <p style="font-size: 20px; color: #617173;">
              設計「醫院中醫科+中醫館連鎖+中醫藥企業+跨境執業」四大體驗路線，學生可通過VR虛擬職場提前實踐。
            </p>
            <el-divider style="width: 1100px;margin-left: 30px" />
            <p style="font-size: 20px; color: #617173;">
              「校友導師智庫」
            </p>
            <p style="font-size: 20px; color: #617173;">
              匹配近五年畢業生擔任成長導師，提供行業動態解讀與求職策略指導。
            </p>
          </div>
        </div>
      </el-main>
      <el-divider style="width: 1350px;margin-left: 30px" />
      <el-footer>
        <div>
          <div style="color: #617173; text-align:center; font-size: 10px;margin-bottom: 10px">
            華夏青年中醫協會
          </div>
          <div style="margin-left: 610px; margin-bottom: 20px">
            <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto">
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Service2"
}
</script>

<style scoped>

</style>
